import { Component, OnInit } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { RunnableLookupCopyState } from '../enums/runnable-lookup-copy-state';

@Component({
  selector: 'hb-lookup-copy-confirmation-dialog',
  templateUrl: './lookup-copy-confirmation-dialog.component.html',
  styleUrls: ['./lookup-copy-confirmation-dialog.component.scss'],
})
export class LookupCopyConfirmationDialogComponent implements OnInit {
  hideSub: Subscription;

  title = this.i18NextPipe.transform('ConfirmationDialog.Title');
  messageTop: string;
  messageBottom: string;
  showCancel: boolean = true;
  showCopyWithValues: boolean = true;

  copyLabel = this.i18NextPipe.transform('LookupCopyConfirmationDialog.Copy');
  copyWithValuesLabel = this.i18NextPipe.transform('LookupCopyConfirmationDialog.CopyWithValues');
  cancelLabel = this.i18NextPipe.transform('ConfirmationDialog.Cancel');

  public afterClosed = new Subject<RunnableLookupCopyState>();

  constructor(public bsModalRef: BsModalRef, private modalService: BsModalService, private i18NextPipe: I18NextPipe) { }

  ngOnInit() {
    this.hideSub = this.modalService.onHide.subscribe(() => this.submit(RunnableLookupCopyState.NoCopy));
  }

  submit(result: RunnableLookupCopyState) {
    this.afterClosed.next(result);
    this.hideSub.unsubscribe();
    this.bsModalRef.hide();
  }

  public copyWithValues(): void {
    this.submit(RunnableLookupCopyState.CopyWithValues);
  }

  public copy(): void {
    this.submit(RunnableLookupCopyState.Copy);
  }

  public cancel(): void {
    this.submit(RunnableLookupCopyState.NoCopy);
  }
}
